import { render, staticRenderFns } from "./NewsDateTimeRenderer.vue?vue&type=template&id=26e1eab3&"
import script from "./NewsDateTimeRenderer.vue?vue&type=script&lang=js&"
export * from "./NewsDateTimeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports